import { useJWT } from '@/hooks/useJWT';

export const useAuth = () => {
  const { jwt } = useJWT();

  return {
    isAuthenticated: !!jwt,
  };
};
